'use client';

import Link from 'next/link';
import { cn, DEFAULT_AVATAR_URL } from 'common/utils';
import { MinimizedUserInfoType } from 'service/timeline';

interface SuggestedCreatorsWidgetProps {
  className?: string;
  creators: MinimizedUserInfoType[];
  title?: string;
}

const SuggestedCreatorsWidgetMobile = ({
  className,
  creators,
  title = 'おすすめクリエイター',
}: SuggestedCreatorsWidgetProps) => {
  if (!creators || creators.length === 0) return null;

  return (
    <div
      className={cn('all-font-sans -mx-3 mb-4 bg-white p-3 md:mx-0', className)}
    >
      {/* Widget Header */}
      <h3 className="mb-4 text-sm font-semibold leading-none text-pp-text-primary">
        {title}
      </h3>

      {/* Creators Grid - Horizontal layout */}
      <div className="flex gap-3 overflow-x-auto">
        {creators.map((creator, index) => (
          <CreatorItem key={`${creator.id}-${index}`} creator={creator} />
        ))}
      </div>
    </div>
  );
};

const CreatorItem = ({ creator }: { creator: MinimizedUserInfoType }) => {
  return (
    <Link
      href={`/${creator.username}`}
      className="flex shrink-0 flex-col items-center rounded-2xl bg-gray-100 p-2"
    >
      {/* Avatar with rounded background */}
      <div className="mb-1 flex size-16 items-center justify-center">
        <img
          src={creator?.avatar || DEFAULT_AVATAR_URL}
          alt={creator?.name}
          className="size-12 rounded-full object-cover"
        />
      </div>

      {/* Creator Name */}
      <div
        className="w-[80px] truncate text-center text-xs font-medium text-pp-text-primary"
        title={creator.name}
      >
        {creator.name}
      </div>
    </Link>
  );
};

export default SuggestedCreatorsWidgetMobile;
